import React from "react";

const Landing = () => {
  return <section className="relative">
  <div className="max-w-6xl px-4 mx-auto sm:px-6">
    <div className="pt-32 pb-12 md:pt-40 md:pb-20">
      {/* Section header */}
      Landing
    </div>
  </div>
</section>
};

export default Landing;
